import { type HTMLAttributes } from 'react';
import { cn } from '@discover-lib/utils';

export type CommandShortcutProps = HTMLAttributes<HTMLSpanElement>;

const CommandShortcut = ({ className, ...props }: CommandShortcutProps) => (
  <span
    className={cn('ml-auto text-xs tracking-widest text-muted-foreground', className)}
    {...props}
  />
);

CommandShortcut.displayName = 'CommandShortcut';

export default CommandShortcut;
